import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import ModalComponent from "../../../../../general-ui/modal/modal";
import className from 'classnames';
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import { MarketingRegisteredPage } from "../../../../../live-event/marketing-page/marketing-registered-page";
import { EPreviewTypes } from "../../../../../../types/working-model";
import PreviewEventChatMain from "../../../../../live-event/event-chat/preview-event-chat-main";


interface HomePreviewProps {
	open: boolean;
}

const HomePreviewModal: React.FC<HomePreviewProps> = ({ open }) => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);
	const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const dispatch = useDispatch();

	const modalBody = useMemo(() => {
		return (
			<div className={className("event-preview-wrapper live-event-container home-preview", editorSize)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<MarketingRegisteredPage isCustomPage={previewMode === EPreviewTypes.CustomPage} />
				<PreviewEventChatMain />
			</div>
		);
	}, [workingEvent, editorSize, previewMode]);

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	return (
		<div
			className="preview-modal"
			style={previewMode !== EPreviewTypes.Home ? { display: 'none' } : {}}
		>
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default HomePreviewModal;